// TestimonialsSection.js
import React, { useState } from 'react';
import './TestimonialsSection.css';
import { FaArrowLeft, FaArrowRight } from 'react-icons/fa';

const testimonials = [
    {
        id: 1,
        rating: 5,
        text: "Je remarque que mon corps est plus affiné et plus tonique. J’ai aussi moins de fringales, ce qui m’aide à mieux manger !",
        author: "Lina S.",
    },
    {
        id: 2,
        rating: 5,
        text: "Fini les baisses d’énergie en pleine journée ! Je me sens plus en forme et plus motivée pour mes entraînements.",
        author: "Imane R.",
    },
    {
        id: 3,
        rating: 5,
        text: "J’ai plus d’endurance pendant mes séances de sport et je récupère plus vite après l’effort.",
        author: "Adam K.",
    },
    {
        id: 4,
        rating: 5,
        text: "Je digère beaucoup mieux et je ressens moins de ballonnements. Mon bien-être général s’est nettement amélioré.",
        author: "Sofia M.",
    },
    {
        id: 5,
        rating: 5,
        text: "L’ajout de l’eBook est un vrai plus ! Il m’aide à mieux organiser mes repas et à garder un bon équilibre pendant mon régime.",
        author: "Khadija B.",
    },
    {
        id: 6,
        rating: 5,
        text: "Je me sens plus concentré et plus productif au quotidien. Mon niveau d’énergie est stable du matin au soir.",
        author: "Samir C.",
    },
    {
        id: 7,
        rating: 5,
        text: "Je vois une belle différence sur mon corps, surtout au niveau du ventre. Ce produit m’aide à mieux gérer mon appétit.",
        author: "Inès D.",
    },
    {
        id: 8,
        rating: 5,
        text: "Mon corps est plus dessiné et je ressens moins de rétention d’eau. Je suis vraiment satisfait !",
        author: "Walid A.",
    },
    {
        id: 9,
        rating: 5,
        text: "L’eBook est super utile pour structurer mes repas et éviter les erreurs alimentaires pendant mon programme de perte de poids.",
        author: "Nassim B.",
    },
];

const TestimonialsSection = () => {
    const [currentIndex, setCurrentIndex] = useState(0);

    const handlePrev = () => {
        setCurrentIndex((prevIndex) => (prevIndex === 0 ? testimonials.length - 1 : prevIndex - 1));
    };

    const handleNext = () => {
        setCurrentIndex((prevIndex) => (prevIndex === testimonials.length - 1 ? 0 : prevIndex + 1));
    };

    return (
        <section className="testimonials-section">
            <h2>TESTÉS ET ADORÉS !</h2>
            {/* <p>En plus d'être conçus et testés cliniquement... Voici quelques retours !</p> */}
            <div className="testimonial-card">
                {/* <div className="rating">
                    {Array.from({ length: testimonials[currentIndex].rating }).map((_, index) => (
                        <span key={index}>&#9733;</span>
                    ))}
                </div> */}
                <p className="testimonial-text">“ {testimonials[currentIndex].text} ”</p>
                <p className="author">- {testimonials[currentIndex].author}</p>
                <div className="navigation">
                    <button onClick={handlePrev} className="nav-button nav-button-left">
                        <FaArrowLeft />
                    </button>
                    <button onClick={handleNext} className="nav-button nav-button-right">
                        <FaArrowRight />
                    </button>
                </div>
                <div className="pagination">
                    {testimonials.map((_, index) => (
                        <span
                            key={index}
                            className={`dot ${index === currentIndex ? 'active' : ''}`}
                            onClick={() => setCurrentIndex(index)}
                        ></span>
                    ))}
                </div>
            </div>
        </section>
    );
};

export default TestimonialsSection;
